import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["condensed", "defaultValue", "disableAnimation", "disabled", "error", "hasDegradedPerformance", "hideBullet", "id", "isSingleLine", "name", "omitFirstLine", "omitLastLine", "onAnimationEnd", "onChange", "onClickDisabled", "options", "shouldPaddingLeftBullet", "UNSAFE_containerProps", "value", "warning"];
import React from 'react';
import View from '@bubble-ui/primitive-view';
import { useViewSize } from '@bubble-ui/hook-use-view-size';
import useUncontrolledProp from '@bubble-ui/hook-use-uncontrolled-prop';
import * as Breakpoints from '@bubble-ui/particle-breakpoints';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { useUniqueFormIdentifier } from '@bubble-ui/hook-use-unique-form-identifier';
import usePropDeprecationWarning from '@bubble-ui/hook-use-prop-deprecation-warning';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
import { RadioOption } from './RadioOption';
import { getIds } from './getIds';
var Radio = _ref => {
  var {
      condensed,
      defaultValue,
      disableAnimation,
      disabled,
      error,
      hasDegradedPerformance,
      hideBullet,
      id,
      isSingleLine,
      name,
      omitFirstLine,
      omitLastLine,
      onAnimationEnd,
      onChange,
      onClickDisabled,
      options,
      shouldPaddingLeftBullet,
      UNSAFE_containerProps,
      value,
      warning
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropDeprecationWarning({
    componentName: 'Radio',
    propName: 'hasDegradedPerformance',
    shouldWarn: hasDegradedPerformance !== undefined,
    removalDate: 'v6.0.0'
  });
  usePropDeprecationWarning({
    componentName: 'Radio',
    propName: 'shouldPaddingLeftBullet',
    shouldWarn: shouldPaddingLeftBullet !== undefined,
    removalDate: 'v6.0.0'
  });
  usePropDeprecationWarning({
    componentName: 'Radio',
    propName: 'disableAnimation',
    shouldWarn: disableAnimation !== undefined,
    removalDate: 'v6.0.0',
    useInstead: 'AnimationControlProvider'
  });
  usePropDeprecationWarning({
    componentName: 'Radio',
    propName: 'condensed',
    shouldWarn: condensed !== undefined,
    removalDate: 'v6.0.0',
    useInstead: 'isSingleLine'
  });
  usePropsSpreadingDeprecationWarning({
    componentName: 'Radio',
    props,
    useInstead: 'UNSAFE_containerProps',
    removalDate: 'v7.0.0'
  });
  var [rootViewProps, {
    width: rootWidth
  }] = useViewSize();
  var ids = getIds(id);
  var componentName = useUniqueFormIdentifier({
    name,
    fallbackName: 'Radio'
  });
  var [radioValue, setRadioValue] = useUncontrolledProp({
    prop: value,
    defaultProp: defaultValue,
    onChange
  });
  return /*#__PURE__*/React.createElement(View, _extends({
    id: ids === null || ids === void 0 ? void 0 : ids.container
  }, UNSAFE_containerProps, {
    style: {
      marginBottom: -1
    }
  }, rootViewProps), /*#__PURE__*/React.createElement(View, {
    accessibilityRole: "radiogroup"
  }, options.map((option, index) => /*#__PURE__*/React.createElement(RadioOption, _extends({}, props, {
    disableAnimation: disableAnimation,
    disabled: disabled,
    error: error,
    hasDegradedPerformance: hasDegradedPerformance,
    hideBullet: hideBullet,
    isSingleLine: isSingleLine,
    omitFirstLine: omitFirstLine,
    omitLastLine: omitLastLine,
    onAnimationEnd: onAnimationEnd,
    onClickDisabled: onClickDisabled,
    shouldPaddingLeftBullet: shouldPaddingLeftBullet,
    warning: warning
  }, option, {
    id: ids === null || ids === void 0 ? void 0 : ids.radioOption(index),
    isChecked: option.value === radioValue,
    isFirst: index === 0,
    key: "".concat(option.value, "-").concat(index),
    isLast: index + 1 === options.length,
    hasContentPadding: rootWidth > Breakpoints.MOBILE_MAX_WIDTH,
    name: componentName,
    onChange: setRadioValue,
    condensed: condensed
  })))));
};
Radio.displayName = 'Radio';
export default withProvisionalOverrideFromContext(Radio);
//# sourceMappingURL=index.js.map